// import { canUseDOM } from 'exenv';

export function innovationByDesignDetailLoading(resp = {}, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_DETAIL_LOADING',
    innovationByDesignDetail: resp,
    store
  };
}

export function innovationByDesignDetailLoaded(resp = {}, store = {}, year) {
  return {
    type: 'INNOVATION_BY_DESIGN_DETAIL_LOADED',
    innovationByDesignDetail: resp,
    store,
    year
  };
}

export function innovationByDesignDetailLoadError(error, store = {}) {
  return {
    type: 'INNOVATION_BY_DESIGN_DETAIL_ERROR',
    innovationByDesignDetail: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
